import { findIndex } from 'lodash'
import ApiClient from './ApiClient'

export default class App {
  
  constructor(app = {}) {
    this.id = app.id || null
    this.account_id = app.account_id || null
    this.domain = app.domain || ''
    this.api_client = new ApiClient(app.api_client)
    this.client_id = app.client_id || null
    this.app_key = app.app_key || ''
    this.ip_address = app.ip_address || ''
    this.meta = app.meta || {}
    this.name = app.name || ''
    this.logo_url = app.logo_url || null
    this.laravel_version = app.laravel_version || {}
    this.environments = app.local_environments || []
    this.environments_count = app.environments_count || 0
    this.create_stage_env = app.create_stage_env || false
    this.create_local_dev_env = app.create_local_dev_env || false
    this.standards = app.standards || []
    this.team_id = app.team_id || ''
    this.team = app.team || null
  }

  static mutations() {
    return {
      updateDomain: (state, domain) => state.app.domain = domain,
      updateName: (state, name) => state.app.name = name,
      updateIpAddress: (state, ipAddress) => state.app.ip_address = ipAddress,
      setApp: (state, app) => state.app = new App(app),
      setSetupKeys: (state, setupKeys) => state.setupKeys = setupKeys,
      setLocalEnvs: (state, envs) => state.app.local_environments = envs,
      setLogoUrl: (state, logo) => state.app.logo_url = logo,
      setApiClient: (state, api_client) => state.app.api_client = api_client,
      updateStandards: (state, standards) => state.app.standards = standards,
      setApiClientSecret: (state, secret) => state.app.api_client.secret = secret,
      toggleCreateStageEnv: (state) => state.app.create_stage_env = !state.app.create_stage_env,
      toggleCreateLocalDevEnv: (state) => state.app.create_local_dev_env = !state.app.create_local_dev_env,
      setTeam: (state, team) => state.app.team = team,
      removeLocalEnv: (state, envId) => {
        let index = findIndex(state.app.local_environments, env => env.id === envId)
        state.app.local_environments.splice(index, 1)
      },
      addTestEnv: (state, payload) => {
        let app = payload.app
        app.api_client = payload.api_client
        state.app.local_environments.push(app)
      },
      setLocalEnvSecret: (state, payload) => {
        let index = findIndex(state.app.local_environments, localEnv => localEnv.client_id === payload.clientId)
        let app = state.app.local_environments[index]
        app.api_client.secret = payload.secret
        state.app.local_environments.splice(index, 1, app)
      },
      addApiClientToLocalEnv: (state, payload) => {
        let index = findIndex(state.app.local_environments, localEnv => localEnv.id === payload.appId)
        let app = state.app.local_environments[index]
        app.api_client = payload.apiClient
        state.app.local_environments.splice(index, 1, app)
      },
      clear: (state) => state.app = new App(),
      updateTeam: (state, payload) => state.app.team_id = payload,
    }
  }
}